function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { getRandomBytes } from "expo-crypto";
import * as SecureStore from "expo-secure-store";
import { Platform } from "react-native";
import { MMKV } from "react-native-mmkv";
import { btoa } from "@oui/lib/src/parseJwt";
var scopes = [
    'apollo',
    'bot'
];
var mmkvInstances = {};
function getSecretKey() {
    var numBytes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 64;
    var newKeyData = getRandomBytes(numBytes);
    var pieces = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newKeyData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var byte = _step.value;
            pieces.push(String.fromCharCode(byte));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return btoa(pieces.join(''));
}
function getEncryptionKeyForMmkv(scope) {
    var storageKey = "mmkvKey_".concat(scope);
    var storedSecret = SecureStore.getItem(storageKey, {
        keychainAccessible: SecureStore.WHEN_PASSCODE_SET_THIS_DEVICE_ONLY
    });
    if (storedSecret) return storedSecret;
    var newKey = getSecretKey();
    SecureStore.setItem(storageKey, newKey, {});
    return newKey;
}
/**
 * Returns an encrypted `MMKV` instance for the provided `scope`.
 *
 * The instance can be used to securely store sensitive data on device. `MMKV`
 * may be preferred over `SecureStore` when storing larger quantities of data
 * due to `SecureStore`'s storage value limits.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-154}
 */ export var getMmkv = function(scope) {
    if (Platform.OS === 'web') throw new Error('MMKV is not supported on web platform');
    if (mmkvInstances[scope]) return mmkvInstances[scope];
    if (process.env.NODE_ENV === 'test') {
        mmkvInstances[scope] = new MMKV({
            id: "".concat(scope, "_store")
        });
        return getMmkv(scope);
    }
    var newInstance = new MMKV({
        id: "".concat(scope, "_store"),
        encryptionKey: getEncryptionKeyForMmkv(scope)
    });
    mmkvInstances[scope] = newInstance;
    return newInstance;
};
/** @nosync */ export var clearAll = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (Platform.OS === 'web') return [
                2
            ];
            scopes.map(function(scope) {
                return getMmkv(scope).clearAll();
            });
            return [
                2
            ];
        });
    });
    return function clearAll() {
        return _ref.apply(this, arguments);
    };
}();
